<template>
	<el-dialog :title="$t('common.delete')" :visible.sync="visible" width="30%">
		<p>{{ $t('common.deleteConfirm') }}</p>

		<span slot="footer" class="dialog-footer">
			<el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
			<el-button type="primary" @click="confirmDelete">{{ $t('common.confirm') }}</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import {
		deleteOwnerRepair,
		deleteOrder
	} from '@/api/work/repairPoolManageApi'
	import {
		getCommunityId
	} from '@/api/community/communityApi'

	export default {
		name: 'DeleteOwnerRepair',
		deleteOrder,
		data() {
			return {
				visible: false,
				repairId: ''
			}
		},
		methods: {
			open(_repair) {
				this.repairId = _repair.repairId
				this.visible = true
			},

			async confirmDelete() {
				try {
					const ret = await deleteOrder({
						orderId: this.repairId,
						communityId: getCommunityId()
					})
					this.$message.success(this.$t('common.deleteSuccess'))
					this.visible = false
					this.$emit('success')


				} catch (error) {
					this.$message.error(error)
					this.visible = false
					this.$emit('false')
				}
			}
		}
	}
</script>